import type { GetUsersListItem } from "@birdwatch/client";

import Avatar from "@/components/ui/avatar/avatar";

import type { FilterOption } from "../types";

/**
 * User → `FilterOption` mapper for the declarative entity filters. The chip pill
 * is a small outlined avatar so several of them overlap legibly; the option-row
 * body is the name, with an italic "Inactive" marker for a deactivated user —
 * the pickers list those on purpose, because a conversation or an order they
 * touched is still worth finding. Shared by every user picker so they render
 * identically.
 */
export function toUserFilterOption(user: GetUsersListItem): FilterOption {
  return {
    value: user.id,
    label: user.name,
    icon: <Avatar src={user.avatarUrl || ""} name={user.name} size="sm" />,
    pill: (
      <Avatar
        src={user.avatarUrl || ""}
        name={user.name}
        size="xs"
        className="outline outline-outline-light-max"
      />
    ),
    detail: (
      <span className="text-sm leading-5 font-normal text-text-dark-max line-clamp-1 break-all">
        {user.name}
        {!user.isActivated && (
          <>
            <span className="mx-1">-</span>
            <span className="italic text-text-dark-low">Inactive</span>
          </>
        )}
      </span>
    ),
  };
}
